/** Days from today to **`yyyy-mm-dd`** (UTC date arithmetic). */
export function daysUntilIsoDate(isoDate: string): number {
  const [y, m, d] = isoDate.slice(0, 10).split("-").map(Number) as [number, number, number];
  const target = Date.UTC(y, m - 1, d);
  const now = new Date();
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.floor((target - today) / 86_400_000);
}

export type MedCredentialTone = "ok" | "warn" | "critical" | "expired";

export function medCredentialTone(daysLeft: number): MedCredentialTone {
  if (daysLeft < 0) return "expired";
  if (daysLeft < 3) return "critical";
  if (daysLeft < 14) return "warn";
  return "ok";
}

export function medCredentialLabel(daysLeft: number): string {
  if (daysLeft < 0) return "Expired";
  if (daysLeft === 0) return "Expires today";
  if (daysLeft === 1) return "1 day";
  if (daysLeft < 14) return `${daysLeft} days`;
  return `${daysLeft} days`;
}
